import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';

@NgModule()
export class QueueMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: QueueMetaModule,
            providers: [
                providePageMeta({
                    title: 'Queues',
                    translationKey: 'page_queues',
                    routerLink: '/queues',
                    sidebarSection: 'Automations',
                    svgIcon: 'uipath:queues',
                    permission: 'Queues.View',
                    type: 'Sidebar',
                    category: PageCategory.Tenant,
                    priority: 2,
                    scope: PageScope.Folder,
                }),
                providePageMeta({
                    title: 'Add Queue',
                    translationKey: 'page_queues_add',
                    routerLink: '/queues/add',
                    permission: 'Queues.Create',
                    type: 'Breadcrumb',
                    category: PageCategory.Tenant,
                    parentRoute: '/queues',
                    scope: PageScope.Folder,
                }),
                providePageMeta({
                    title: 'Edit Queue',
                    translationKey: 'page_queues_edit',
                    routerLink: '/queues/:id/edit',
                    permission: 'Queues.Edit',
                    type: 'Breadcrumb',
                    category: PageCategory.Tenant,
                    parentRoute: '/queues',
                    scope: PageScope.Folder,
                }),
            ],
        };
    }
}
